import { defineComponent as _defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnotationImageDownload',
  setup(__props) {

const route = useRoute();
const router = useRouter();

// const downloadImage = async () => {
const token = JSON.parse(localStorage.getItem(`auth-tokens-${process.env.NODE_ENV}`)!);
const isGallery = route.query.gallery === '1';
const endpoint = isGallery
  ? `${process.env.VUE_APP_API_URL}/gallery_annotations/${route.params.annotation}/image`
  : `${process.env.VUE_APP_API_URL}/annotations/${route.params.annotation}/image`;

fetch(endpoint, {
  headers: {
    'Authorization': `Bearer ${token.accessToken}`
  }
})
  .then(blobResponse => {
    if ( blobResponse.ok ) {
      return blobResponse.blob();
    }

    throw new Error();
  })
  .then(blob => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a')
    a.href = url;
    a.setAttribute('download', `annotation_image_${route.params.annotation}.jpeg`);

    document.body.appendChild(a)
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  })
  .catch(() => {
    router.push({ name: 'visionair-inspection', params: { inspection: route.params.inspection }, query: { view: 2 }})
  })
  .finally(() => {
    const query = isGallery
      ? {}
      : {
        view: 2,
        annotation: route.params.annotation,
        showMenu: 'open'
      };

    router.push({
      name: 'visionair-inspection',
      params: { inspection: route.params.inspection }, query
    })
  })

return () => {}
}

})